function measureTextWidth(content: string | number, font: string) {
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")!

  ctx.font = font

  return ctx.measureText(`${content}`).width
}

export function createSVGIcon(
  name: string,
  count: number | string,
  employeeCount?: number | string,
  industryCategory = "门店",
  strokeColor = "#00FFB4",
  fillColor = "#050f3d",
  textColor = "#00FFA9",
  textColor2 = "#fff",
) {
  const hasEmployee = typeof employeeCount === "number"
  const countWidth =
    measureTextWidth(`${count}`, '20px "Digital-7Mono, Digital-7 Mono"') + (count <= 1000 ? 10 : 15)
  let employeeCountWidth = 0

  if (hasEmployee) {
    employeeCountWidth =
      measureTextWidth(employeeCount, '20px "Digital-7Mono, Digital-7 Mono"') +
      (employeeCount <= 1000 ? 10 : 15)
  }

  const textWidth = countWidth + employeeCountWidth - (hasEmployee ? 0 : 20)
  const svgWidth = 223 + textWidth
  const rectWidth = 100 + +textWidth
  const circleCX = 180 + textWidth
  return `
      <svg width="${svgWidth}" height="84"
        xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <g>
                <rect stroke="${strokeColor}" fill-opacity=".9" fill="${fillColor}" x=".5" y=".5" width="${rectWidth}" height="79" rx="8"/>
                <text font-family="PingFangSC-Regular, PingFang SC" font-size="12" fill="${textColor}">
                    <tspan x="14" y="23">${name}</tspan>
                </text>
                <text font-family="Digital-7Mono, Digital-7 Mono" font-size="20" fill="${textColor}">
                    <tspan x="28" y="49">${count.toLocaleString()}</tspan>
                </text>
                <text font-family="PingFangSC-Regular, PingFang SC" font-size="12" fill="${textColor2}">
                    <tspan x="28" y="66">${industryCategory}</tspan>
                </text>
                ${
                  hasEmployee
                    ? `<text font-family="Digital-7Mono, Digital-7 Mono" font-size="20" fill="${textColor}">
                        <tspan x="${
                          60 + countWidth
                        }" y="49">${employeeCount.toLocaleString()}</tspan>
                       </text>
                       <text font-family="PingFangSC-Regular, PingFang SC" font-size="12" fill="${textColor2}">
                        <tspan x="${60 + countWidth}" y="66">员工</tspan>
                       </text>`
                    : ""
                }
                <path stroke="${strokeColor}" d="M${rectWidth} 52h52.328l27 27"/>
                <circle fill="${strokeColor}" opacity=".403" cx="${circleCX}" cy="79.5" r="4.5"/>
                <circle fill="${strokeColor}" cx="${circleCX}" cy="79.5" r="2.25"/>
            </g>
            <text transform="translate(${countWidth} 34)" fill="${textColor}" font-family="PingFangSC-Regular, PingFang SC" font-size="10">
                <tspan x="23" y="15">家</tspan>
            </text>
            ${
              hasEmployee
                ? `<text transform="translate(${
                    25 + textWidth
                  } 34)" fill="${textColor}" font-family="PingFangSC-Regular, PingFang SC" font-size="10">
                    <tspan x="31" y="15">人</tspan>
                   </text>`
                : ""
            }
        </g>
    </svg>
  `
}

export function svgToDataURL(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
